export default {
  'menu.dishes.title': '菜品',
  'menu.dishes.column.image': '图片',
  'menu.dishes.column.category': '分类',
  'menu.dishes.column.name': '菜品名称',
  'menu.dishes.column.foreignName': '中文名称',
  'menu.dishes.column.printers': '打印机',
  'menu.dishes.column.updatedAt': '更新日期',
  'menu.dishes.column.description': '描述',

  'menu.dishes.edit.title': '编辑菜品',
  'menu.dishes.edit.section.details': '信息',
  'menu.dishes.edit.section.printer': '关联打印机',
  'menu.dishes.edit.section.customizations': '附加选项',
  'menu.dishes.edit.section.price': '价格',
  'menu.dishes.edit.section.categories': '关联分类',

  'menu.dishes.noPrinters': '没有关联打印机',

  'menu.dishes.action.addPrinter': '添加打印机',
  'menu.dishes.openPrice': '价格自定义',
  'menu.dishes.price': '价格',

  'menu.dishes.pickup.price': '自取价格',
  'menu.dishes.delivery.price': '递送价格',
};
